<h3 class="op-widget-box--header"
  data-test-selector="op-widget-box--header"
  [ngClass]="{ '-editable': isRenameable }">
  @if (drag.isDraggable) {
    <svg
      grabber-icon
      size="small"
      cdkDragHandle
    class="grid--area-drag-handle hidden-for-mobile"></svg>
  }

  <ng-content select="[slot=prepend]" />

  <editable-toolbar-title [title]="name"
    (onSave)="renamed($event)"
    [editable]="isRenameable"
    class="op-widget-box--header-title" />

  <ng-content select="[slot=menu]" />
</h3>
